module.exports = __webpack_public_path__ + "static/img/arduino_mega_2560_cabo-2.6e6797f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/arduino_mega_2560_cabo-2.svg
// module id = ANzQ
// module chunks = 0